// extracted by mini-css-extract-plugin
module.exports = {"intro":"About_intro__Qp3_d","items":"About_items__S9LrK","content":"About_content__Sge6n","item":"About_item__wEive"};